import React from 'react';
import goshinjitsu1 from '../assets/goshinjitsu1.png';
import goshinjitsu2 from '../assets/goshinjitsu2.png';
import logo2 from '../assets/logo2.png';
import background from '../assets/background.png';

export default function GoshinJitsu() {
  const pageStyle = {
    // 70% white overlay on top of the background image -> image appears ~30% visible
    backgroundImage: `linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url(${background})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
  };

  const contentStyle = {
    maxWidth: 900,
    margin: '0 auto',
    padding: '32px 16px 48px',
    color: '#111',
    lineHeight: 1.6,
  };

  const sectionStyle = {
    margin: '32px 0',
    paddingBottom: 16,
    borderBottom: '1px solid rgba(0,0,0,0.08)',
  };

  const photoStyle = {
    width: 260,
    maxWidth: '100%',
    display: 'block',
    margin: '0 auto 12px',
    borderRadius: 12,
    boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
  };

  const poweredByStyle = {
    textAlign: 'center',
    marginTop: 40,
  };

  const h1Style = { textAlign: 'center', marginBottom: 24 };
  const h2Style = { textAlign: 'center' };

  return (
    <div className="Instructors" style={pageStyle}>
      <div style={contentStyle}>
        <h1 style={h1Style}>
          Aiki Goshin Jitsu (Self-Defense Techniques Based on Aikido Principles)
        </h1>

        <section className="instructor" style={sectionStyle}>
          <img
            style={photoStyle}
            src={goshinjitsu1}
            alt="Motohiro Fukakusa Shihan (photo 1)"
          />

          <h2 style={h2Style}>
            MOTOHIRO FUKAKUSA SHIHAN — 8th Dan, Aikikai (Founder, Aiki Goshin Jitsu)
          </h2>

          <img
            style={photoStyle}
            src={goshinjitsu2}
            alt="Motohiro Fukakusa Shihan (photo 2)"
          />

          {/* Longer Goshin Jitsu description */}
          <p>
            <strong>Aiki Goshin Jitsu</strong> is a practical self-defense study developed from
            Aikido principles and adapted for real-world situations. The goal is not to “fight”
            or compete, but to help practitioners respond calmly, decisively, and safely when
            facing common street-level threats. Training emphasizes awareness, correct distance
            (ma-ai), timing, posture, and controlled movement—so that students can protect
            themselves while avoiding unnecessary injury to others whenever possible.
          </p>

          <p>
            The system focuses on <strong>simple, reliable responses</strong> to realistic
            grabs, holds, pushes, strikes, and intimidation scenarios. Rather than relying on
            strength, Aiki Goshin Jitsu uses body alignment, turning (tai-sabaki), off-balancing
            (kuzushi), and leverage to escape and regain control. Students learn how to protect
            vital targets, how to move to safer angles, and how to use the attacker’s momentum
            to create openings for disengagement.
          </p>

          <p>
            Practice commonly includes <strong>escape methods</strong> from wrist grabs, lapel
            grabs, bear hugs, and headlocks; <strong>control techniques</strong> such as pins,
            immobilizations, and safe restraint; and <strong>finishing options</strong> that
            prioritize ending the danger quickly—often by creating space to exit. In addition,
            students are taught <strong>situational judgment</strong>: when to de-escalate, when
            to break contact, and when to seek help. This “decision-making” aspect is a key
            part of self-defense, because the best technique is often the one that prevents the
            situation from becoming physical at all.
          </p>
          <p>
            Fukakusa Shihan established “Goshinjutsu” as practical training for Thai Aikikai
            members. Moreover, he frequently travels abroad to conduct seminars and is invited
            to instruct airline crews, law enforcement, and the military in Thailand and other
            countries.
          </p>
        </section>

        <footer className="powered-by" style={poweredByStyle}>
          <div>Powered by</div>
          <img
            className="logo2"
            src={logo2}
            alt="New Wave Consulting Group"
            style={{ height: 50, display: 'block', margin: '8px auto' }}
          />
          <div>New Wave Consulting Group</div>
        </footer>
      </div>
    </div>
  );
}
